import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import Loader from 'components/Loader';
import Button from 'components/Button';

import {fetchApps,installApp} from 'actions';
import WithNotifications from 'containers/WithNotifications';

import './oauth.css';

class OAuth extends PureComponent{
    constructor(props){
        super(props);
        this.state={installing:true, loaded:false};
    }
    componentDidMount(){
        this.props.fetchApps()
        .then(() => {
            this.setState({loaded:true});
            this.installApp(this.props.app);
        }) 
    }
    installApp(app){
        const {location} = this.props;
        const queryParams = this.parseQuery(location.search);
        if (this.props.auth.secret) queryParams.secret = this.props.auth.secret;
        if (app.initialAuthURL) queryParams.isCustomOAuth = true; // support for salesforce
        this.props.installApp(app,queryParams)
        .then(() => {
            this.props.addNotification('success',`${app.name || 'App'} installed successfully`);
            this.context.router.history.push('/apps');
        })
        .catch((err)=>{
            console.log(err)
            this.props.addNotification('error','There was a problem installing the integration');
            this.setState({installing:false,error:true})
        })
    }
    parseQuery(search){
        const searchParams = new URLSearchParams(search);
        let obj={};
        for(let pair of searchParams.entries()) {
            obj[pair[0]]=pair[1];
        }
        return obj;
    }
    render(){
        console.log(JSON.stringify(this.props));
        const {app} = this.props;
        return (
            <div className="cl-oauth-app">
                {this.state.installing ?
                    <div className="cl-oauth-installing">
                        {this.state.loaded ?
                            <div className="cl-app-installing center-xs middle-xs">
                                <h1>Installing {app.name}...</h1>
                                <img width="120" src={app.logoGraphic} alt={this.props.name}/>
                            </div>
                        :null }
                        <Loader/>
                    </div>
                : null}
                {this.state.error ?
                    <div className="cl-oauth-installing-error">
                        {app ?
                            <div className="cl-app-installing center-xs middle-xs">
                                <h1 className="cl-error-msg">Installing {app.name} Failed</h1>
                                <img width="120" src={app.logoGraphic} alt={this.props.name}/>
                                <Link to="/apps">
                                    <Button className="cl-oauth-back" styling="secondary">Back to Integrations</Button>
                                </Link>
                            </div>
                        :null }
                    </div>
                :null }
            </div>
        )
    }
}

OAuth.contextTypes = {
    router:PropTypes.object
}

function mapStateToProps(state,props){
    return {
        apps:state.apps,
        // app:state.apps && state.apps.find(app => app.source === props.match.params.name),
        app:state.apps && state.apps.find(app => app.source === props.match.params.name && window.location.hostname.indexOf(app.brand) !== -1),
        auth:state.auth,
        integrations:state.integrations
    }
}

export default WithNotifications(connect(mapStateToProps,{fetchApps,installApp})(OAuth))


// WEBPACK FOOTER //
// ./src/scenes/OAuth/index.js